/**
 * Context menu for listing storables.
 */
import * as ArchiveActions from 'archive/ArchiveActions';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import isArchived from 'archive/isArchived';
import * as contextmenu from 'components/ContextMenu';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import preferences from 'Preferences';
import copyToClipboard from 'util/clipboard/copyToClipboard';
import runModal from 'ui-library/runModal';
import PrintBarcodeModal from 'label-printing/PrintBarcodeModal';
import {dispatchRemoveWorklistItems} from 'worklists/WorklistActions';

// Export function for testing.
export function _getContextMenuOptions(storable) {
  return [
    {
      name: 'Open',
      click() {
        FileBrowserActions.openFile(storable.id);
      },
      dataTestAttrs: {component: 'StorableContextMenu', element: 'open'},
    },
    '-',
    {
      name: 'Remove from worklist',
      click() {
        dispatchRemoveWorklistItems(storable.worklistId, [storable.id], {
          refreshWorklistItemsSearch: true,
          refreshRecentWorklists: true,
        });
      },
      hide() {
        return !storable.worklistId;
      },
    },
    '-',
    {
      name: 'Archive',
      click() {
        ArchiveModal.open({items: [storable], onArchive: ArchiveActions.bulkArchiveStorablesWithDataMods});
      },
      disabled() {
        return !storable.permissions.archivable;
      },
      hide() {
        return isArchived(storable);
      },
    },
    {
      name: 'Unarchive',
      click() {
        ArchiveActions.bulkUnarchiveStorablesWithDataMods([storable.id]);
      },
      disabled() {
        return !storable.permissions.unarchivable;
      },
      hide() {
        return !isArchived(storable);
      },
    },
    {
      name: 'Print',
      click() {
        runModal(PrintBarcodeModal, {itemIds: [storable.id]});
      },
    },
    '-',
    {
      name: 'Copy API ID',
      click() {
        copyToClipboard(storable.id, {showToastOnSuccess: true});
      },
      hide() {
        return !preferences.get('ENABLE_COPY_API_ID');
      },
    },
  ];
}

export function open(e, storable) {
  contextmenu.view.open(e, _getContextMenuOptions(storable));
}
